var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "beenCourse" },
    [
      _vm.lessonList.length
        ? _c(
            "ul",
            { staticClass: "lessonBox" },
            _vm._l(_vm.lessonList, function (item, index) {
              return _c(
                "li",
                { key: index, staticClass: "col col-sm-6 col-md-4 lesson-li" },
                [
                  _c("div", [
                    _c("div", { staticClass: "lessoncover" }, [
                      item.work && item.work.cover
                        ? _c("img", {
                            class: item.work ? "curp" : "",
                            attrs: { src: item.work.cover, alt: "" },
                            on: {
                              click: function ($event) {
                                return _vm.goPlay(item)
                              },
                            },
                          })
                        : item.lesson && item.lesson.pptCover
                        ? _c("img", {
                            attrs: { src: item.lesson.pptCover, alt: "" },
                          })
                        : _c("img", {
                            attrs: { src: _vm.defaultCover, alt: "" },
                            on: {
                              click: function ($event) {
                                return _vm.goPlay(item)
                              },
                            },
                          }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "top" }, [
                      _c("span", { staticClass: "flex" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              item.lesson
                                ? item.lesson.name
                                  ? item.lesson.name
                                  : " "
                                : " "
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "flex" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              `${item.date ? item.date : ""} ${
                                item.week ? _vm.hebdomad[item.week - 1] : ""
                              }`
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              `${item.startTime ? item.startTime : ""}-${
                                item.endTime ? item.endTime : ""
                              }`
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "flex" },
                        [
                          _c(
                            "div",
                            { staticStyle: { height: "35px" } },
                            [
                              _c("img", {
                                attrs: { src: item.teacherAvatar, alt: "" },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.teacherName))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "lesson-one" }, [
                                _vm._v(
                                  _vm._s(
                                    item.onlineTeaching ? "线上课" : "线下课"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              item.taskList &&
                              item.taskList &&
                              item.taskList.length
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goHomeWork(item)
                                        },
                                      },
                                    },
                                    [_vm._v("作业")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.classVideos && item.classVideos.length
                            ? _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.playLessonVideo(item)
                                    },
                                  },
                                },
                                [_vm._v("课堂回放")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.lessonList.length == 0
        ? _c("span", { staticClass: "default" }, [
            _c("img", {
              attrs: { src: require("@/assets/icon/notdata.png"), alt: "" },
            }),
            _vm._v("\n        暂时没有已上课程\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.lessonList.length
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              "page-size": 8,
              total: _vm.totalElements,
            },
            on: { "current-change": _vm.handlePagination },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "课堂回放",
            "close-on-click-modal": false,
            visible: _vm.videoDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.videoDialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c("video", {
            ref: "videoPlayer",
            attrs: {
              width: "100%",
              controlslist: "nodownload noremoteplayback",
              src: _vm.lessonVideo,
              id: "guideVideo",
              controls: "controls",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/lesson/component/beenCourse.vue?vue&type=template&id=7b529806&
// module id = null
// module chunks = 